export const newProductCategory = {
  attributes: {
    name: '',
  },
}
